import { Tree } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";

import { ClassesTreeStore } from "./ClassesTreeStore";

type PropsClassesTree = {
  treeStore: ClassesTreeStore;
  onChangeNode(parentId: string | undefined): void;
};

export const ClassesTree: React.FC<PropsClassesTree> = observer((props) => {
  const { treeStore, onChangeNode } = props;
  return (
    <Tree.DirectoryTree
      treeData={treeStore.visualTree}
      loadData={(node) => treeStore.loadBranch(node)}
      selectedKeys={treeStore.selectedKeys}
      onSelect={(keys: React.Key[]) => {
        const key: string | undefined = (keys as string[])[0];
        treeStore.setActiveNodeKey(key ?? null);
        const node = treeStore.findRootNodeByKey(key ?? "");
        onChangeNode(node?.id);
      }}
    />
  );
});
